<template>
<div class="min-h-screen">
  <div class="pagination-bg pagination-bg-sm pagination-bg-lg pagination-bg-2xl bg-center">
    <div class="max-w-7xl mx-auto pt-16 sm:pt-20">
    <div class="flex justify-center"><img src="@/assets/contact.svg" alt="聯絡我們" class="sm:w-16 sm:h-16"/></div>
    <h1 class="text-3xl sm:text-4xl font-black mt-5">聯絡我們</h1>
    </div>
  </div>
  <div class="max-w-7xl mx-auto mt-10 pb-20 px-10">
    <div class="flex space-x-5 justify-start mb-16">
      <router-link to="/">
      <div class="font-bold text-lg">首頁</div>
      </router-link>
      <p class="text-lg">></p>
      <p class="text-lg text-color-blue font-bold text-left">聯絡我們</p>
    </div>
    <div class="flex items-center space-x-5 mb-10">
      <div class="title-dots-brown"></div>
      <h2 class="text-2xl font-bold text-color-brown">植物標本館成員</h2>
    </div>
    <div class="py-8 px-12 bg-color-brown rounded-3xl text-left text-lg" v-html="associatesContent"></div>
    <div class="flex sm:items-center items-start space-x-5 mt-20 mb-10">
      <div class="title-dots-blue flex-none mt-1 sm:mt-0"></div>
      <h2 class="text-2xl font-bold text-color-blue text-left">中心植物分類<br class="sm:hidden">相關研究人員</h2>
    </div>
    <div class="py-3 px-12 bg-color-blue rounded-3xl text-left divide-y divide-gray-400">
      <!-- 第一筆研究人員資料Start -->
      <div v-for="contact in contacts" :key="contact.id" class="pt-5 mb-5 sm:flex sm:space-x-5">
        <p class="text-lg font-bold text-color-dark-blue flex-none">{{ contact.name }}</p>
          <div>
            <p class="text-lg">{{ contact.job_title }}</p>
            <div class="text-lg text-left"><span>專研類群：</span><span>{{ contact.research_group }}</span></div>
            <div class="md:flex md:space-x-5">
            <div class="text-lg text-left"><span>分機：</span><span>{{ contact.phone }}</span></div>
            <div class="text-lg text-left"><div class="sm:flex"><p>電子信箱：</p><p class="break-all">{{ contact.email }}</p></div></div>
          </div>
        </div>
      </div>
      <!-- 第一筆研究人員資料End -->
    </div>
    <div class="p-8 mt-20 border-dashed border-4 border-style text-left">
      <p class="text-left text-lg mb-5">只要您有任何與農業部生物多樣性研究所標本館相關的需求，您可以透過下列地址、電話或電子信箱聯絡我們。
         本館提供植物研究人員查閱標本及學校團體參觀教學服務，如欲查閱標本或教學參觀，請事先聯絡申請，以便安排相關事宜。</p>
      <div class="grid md:grid-cols-5 gap-y-3">
        <div class="sm:col-span-3">
          <p class="text-lg text-left">地址：552 南投縣集集鎮民生東路一號</p>
        </div>
        <div class="sm:col-span-2">
          <p class="text-lg text-left">信箱：taie@tbri.gov.tw</p>
        </div>
        <div class="sm:col-span-3">
          <p class="text-lg text-left">電話：(049) 276-1331 #213</p>
        </div>
        <div class="sm:col-span-2">
          <p class="text-lg text-left">傳真：(049) 276-1801</p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="footer-bg"></div>
</template>

<script>
import { getAssociates } from '@/api/associates'
import { getContacts } from '@/api/contacts'

export default {
  name: "Contacts",
  title: '聯絡我們-TAIE',
  data() {
    return {
      associatesContent: "",
      content: "",
      contacts: [],
    };
  },
  mounted() {
    getAssociates(300).then(
      (response) => {
        this.associatesContent = response.data.content;
      },
      (error) => {
        this.associatesContent =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

    getContacts().then(
      (response) => {
        this.contacts = response.data
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>

<style scoped>
@media (min-width: 1536px) {
  .pagination-bg-2xl {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1536.jpg");
  }
}

@media (min-width: 1024px) and (max-width: 1535.98px) {
  .pagination-bg-lg {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over1024.jpg");
  }
}

@media (min-width: 640px) and (max-width: 1023.98px) {
  .pagination-bg-sm {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/pagination-bg-over640.jpg");
  }
}

@media (max-width: 639.98px) {
  .pagination-bg {
    width: 100%;
    height: 250px;
    background-image: url("../../assets/pagination-bg-under640.jpg");
  }
}

a:hover {
color:#64859D;
}

.text-color-blue {
  color: #64859D;
}

.text-color-brown {
  color: #C9A798;
}

.text-color-dark-blue {
  color: #466176;
}

.text-color-dark-brown {
  color: #6D5B53;
}

.bg-color-brown {
  background-color: #EEEBE9;
}

.bg-color-blue {
  background-color: #E5E9EC;
}

.title-dots-blue {
  width: 28px;
  height: 25px;
  background-color: #64859D;
  mask-image: url(../../assets/contact-dots.svg);
}

.title-dots-brown {
  width: 28px;
  height: 25px;
  background-color: #C9A798;
  mask-image: url(../../assets/contact-dots.svg);
}

.border-style{
  border-color: #64859D;
  border-radius: 30px;
}

.footer-bg {
  width: 100%;
  height: 10px;
  background-image: url("../../assets/footer-bg.svg");
}
</style>
